import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarTableService {
  private filterSubject = new BehaviorSubject<any>(null);
  private filters: Record<string, any> = {};

  private resetSubject = new Subject<string>;

  constructor() {
    this.getFilters$.subscribe({
      next: filters => {
        this.filters = filters;
      }
    });
  }

  get resetTable$(): Observable<string> {
    return this.resetSubject.asObservable();
  }

  resetTable(): void {
    this.resetSubject.next(new Date().getTime().toString());
  }

  get getFilters$(): Observable<Record<string, any>> {
    return this.filterSubject.asObservable();
  }

  addFilters(filter: Record<string, any>): void {
    if (Object.keys(filter).length > 0) {
      console.log('add filters', filter);
      this.filters = { ...this.filters, ...filter };
      this.filterSubject.next(this.filters);
    }
  }

  renewFilters(filter: Record<string, any>): void {
    this.filterSubject.next(filter);
  }

  clearFilters() {
    console.log('clear filters');
    this.filterSubject.next({});
  }

}
